import React, { Component } from 'react';

class Tietosuoja extends Component {

  render() {
    return (<div>
      <h2>Rekisteri- ja tietosuojaseloste</h2>
      Tämä on SleakBitin joulujahdin henkilötietolain (10 ja 24 §) ja EU:n yleisen tietosuoja-asetuksen (GDPR) mukainen rekisteri- ja tietosuojaseloste.
      <br />
      <b>Päivitetty 20.11.2025</b>
      <br />
      <br />
      <h4>1. Rekisterinpitäjä</h4>
      SleakBit<br />
      <br />
      <br />
      <h4>2. Rekisteristä vastaava yhteyshenkilö</h4>
      Viljami Virtanen<br />viljami@vilkkuv.fi
      <br />
      <br />
      <h4>3. Rekisterin nimi</h4>
      SleakBit joulujahdin osallistujarekisteri
      <br />
      <br />
      <h4>4. Oikeusperuste ja henkilötietojen käsittelyn tarkoitus</h4>
      EU:n yleisen tietosuoja-asetuksen mukainen oikeusperuste henkilötietojen käsittelylle on henkilön suostumus (dokumentoitu, vapaaehtoinen, yksilöity, tietoinen ja yksiselitteinen). Ennen suostumusta henkilötietojen käsittelyyn, käyttäjä ei voi käyttää palvelua.
      Henkilötietojen käsittelyn tarkoitus on tarjota käyttäjälle joulukalenterimainen kokemus, joka koostuu erilaisista tehtävistä. Henkilötietoja käytetään edistyksen tallentamiseen ja kilpailun mahdollistamiseksi muiden käyttäjien kanssa.
      <br />
      <br />
      <h4>5. Rekisterin tietosisältö</h4>
      Rekisteriin tallennettavia henkilötietoja ovat: <br />
      <ul>
        <li>Sähköpostiosoite</li>
        <li>Discord-nimi ja profiilikuva</li>
        <li>Discord-käyttäjän yksilöivä tunnus</li>
        <li>Käyttäjän joulujahdissa tekemät toiminnot</li>
      </ul>
      Tiedot säilytetään rekisterissä niin kauan, kunnes käyttäjää pyytää niiden poistamista tai ne poistetaan palveluntarjoajan päätöksestä.
      <br />
      <br />
      <h4>6. Säännönmukaiset tietolähteet</h4>
      Rekisteriin tallennettavat henkilötiedot haetaan Discord-rajapinnasta. Tietoja ei haeta rajapinnasta silloin, kun käyttäjä ei aktiivisesti käytä palvelua.
      <br />Lisäksi rekisteriin voidaan tallentaa kaikki tiedot, jotka käyttäjä itse syöttää joulujahtiin.
      <br />
      <br />
      <h4>7. Tietojen säännönmukaiset luovutukset ja tietojen siirto EU:n tai ETA:n ulkopuolelle</h4>
      Osallistujan Discord-nimi ja kuva voidaan julkaista ja luovuttaa vapaasti muille osallistujille. Sähköpostia ei luovuteta tai julkaista. Anonymisoituja tilastotietoja, voidaan luovuttaa ja julkaista.
      Tietoja ei siirretä tai luovuteta EU:n tai ETA:n ulkopuolelle.
      <br />
      <br />
      <h4>8. Rekisterin suojauksen periaatteet</h4>
      Rekisterin käsittelyssä noudatetaan huolellisuutta ja tietojärjestelmien avulla käsiteltävät tiedot suojataan asianmukaisesti. Kun rekisteritietoja säilytetään Internet-palvelimilla, niiden laitteiston fyysisestä ja digitaalisesta tietoturvasta huolehditaan asiaankuuluvasti. Rekisterinpitäjä huolehtii siitä, että tallennettuja tietoja sekä palvelimien käyttöoikeuksia ja muita henkilötietojen turvallisuuden kannalta kriittisiä tietoja käsitellään luottamuksellisesti.
      <br />
      <br />

      <h4>9. Tarkastusoikeus ja oikeus vaatia tiedon korjaamista</h4>
      Jokaisella rekisterissä olevalla henkilöllä on oikeus tarkistaa rekisteriin tallennetut tietonsa ja vaatia mahdollisen virheellisen tiedon korjaamista tai puutteellisen tiedon täydentämistä. Mikäli henkilö haluaa tarkistaa hänestä tallennetut tiedot tai vaatia niihin oikaisua, pyyntö tulee lähettää sähköpostilla rekisterinpitäjälle (info@sleakbit.fi). Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).
      <br />
      <br />


      <h4>10. Muut henkilötietojen käsittelyyn liittyvät oikeudet</h4>
      Rekisterissä olevalla henkilöllä on oikeus pyytää häntä koskevien henkilötietojen poistamiseen rekisteristä ("oikeus tulla unohdetuksi"). Niin ikään rekisteröidyillä on muut EU:n yleisen tietosuoja-asetuksen mukaiset oikeudet kuten henkilötietojen käsittelyn rajoittaminen tietyissä tilanteissa. Pyynnöt tulee lähettää sähköpostilla rekisterinpitäjälle (info@sleakbit.fi). Rekisterinpitäjä voi pyytää tarvittaessa pyynnön esittäjää todistamaan henkilöllisyytensä. Rekisterinpitäjä vastaa asiakkaalle EU:n tietosuoja-asetuksessa säädetyssä ajassa (pääsääntöisesti kuukauden kuluessa).
    </div>)
  }
}
export default Tietosuoja
